/* Registru comun de ferestre. Popup-ul de newsletter si fereastra de add-to-cart
   sunt doua module separate in acelasi fisier. Fara registrul asta se puteau
   deschide amandoua peste aceeasi pagina, iar inchiderea uneia debloca scrollul
   cat timp cealalta era inca deschisa. */
window.BiomeModals = window.BiomeModals || {
  _open: {},
  lock: function (name) {
    this._open[name] = true;
    document.documentElement.style.overflow = 'hidden';
  },
  unlock: function (name) {
    delete this._open[name];
    for (var k in this._open) { if (this._open.hasOwnProperty(k)) return; }
    document.documentElement.style.overflow = '';
  },
  any: function () {
    for (var k in this._open) { if (this._open.hasOwnProperty(k)) return true; }
    return false;
  }
};

/* bio|me, fereastra de recomandare la add-to-cart.

   Se deschide DUPA ce clientul adauga un produs, adica exact in momentul de
   intentie maxima. Arata o singura recomandare, cea calculata in
   templates/cart.upsell.liquid, care tine cont de ce e deja in cos si nu
   propune un ingredient pe care clientul il are deja.

   Reguli ca sa nu devina enervanta:
   - apare doar dupa o adaugare facuta de om, nu la incarcarea paginii
   - o singura recomandare, nu o lista
   - nu reapare cand adaugi chiar din fereastra
   - se inchide cu Escape, cu X sau cu click in afara
   - daca nu exista nicio recomandare valida, nu apare deloc
*/
(function () {
  'use strict';

  var q = function (s, c) { return (c || document).querySelector(s); };
  var qa = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  var pendingAdd = false;   // omul tocmai a apasat "adauga in cos"
  var suppress = false;     // adaugarea vine chiar din fereastra, nu redeschidem
  var modal = null;
  var lastFocus = null;

  function money(cents) {
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'RON';
    try {
      return new Intl.NumberFormat('ro-RO', { style: 'currency', currency: currency }).format((Number(cents) || 0) / 100);
    } catch (e) {
      return ((Number(cents) || 0) / 100).toFixed(2).replace('.', ',') + ' lei';
    }
  }

  function closeDrawer() {
    // Tema deschide singura cosul lateral la add-to-cart. Doua panouri peste
    // acelasi moment inseamna haos, deci il inchidem prin butonul lui, ca sa
    // lasam tema sa isi faca propria curatenie de stare.
    var closer = q('#CartDrawer .js-drawer-close');
    if (closer) { closer.click(); return; }
    document.documentElement.classList.remove('js-drawer-open');
  }

  function destroy() {
    if (!modal) return;
    modal.parentNode && modal.parentNode.removeChild(modal);
    modal = null;
    window.BiomeModals.unlock('atc');
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
  }

  function onKey(event) {
    if (event.key === 'Escape' || event.keyCode === 27) destroy();
  }

  function build(payload) {
    var card = q('.br-cart-upsell__item', payload);
    if (!card) return null;

    var remaining = Number(payload.getAttribute('data-remaining')) || 0;

    var overlay = document.createElement('div');
    overlay.className = 'br-atc-modal';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Produs adăugat în coș');

    var shippingLine = '';
    if (remaining > 0) {
      shippingLine = '<p class="br-atc-modal__shipping">Mai ai <strong>' + money(remaining) + '</strong> până la livrare gratuită.</p>';
    } else {
      shippingLine = '<p class="br-atc-modal__shipping is-done">Ai livrare gratuită.</p>';
    }

    overlay.innerHTML =
      '<div class="br-atc-modal__panel">' +
        '<button type="button" class="br-atc-modal__close" aria-label="Închide">&times;</button>' +
        '<p class="br-atc-modal__done"><span aria-hidden="true">✓</span> Adăugat în coș</p>' +
        shippingLine +
        '<p class="br-atc-modal__heading">Merge bine cu ce ai în coș</p>' +
        '<div class="br-atc-modal__card"></div>' +
        '<div class="br-atc-modal__actions">' +
          '<a class="br-atc-modal__cart" href="/cart">Vezi coșul</a>' +
          '<button type="button" class="br-atc-modal__continue">Continuă cumpărăturile</button>' +
        '</div>' +
      '</div>';

    overlay.querySelector('.br-atc-modal__card').appendChild(card.cloneNode(true));
    overlay.querySelector('.br-atc-modal__close').addEventListener('click', destroy);
    overlay.querySelector('.br-atc-modal__continue').addEventListener('click', destroy);
    overlay.addEventListener('click', function (event) {
      if (event.target === overlay) destroy();
    });
    return overlay;
  }

  function show() {
    // Daca e deja o fereastra deschisa (ex. newsletterul), nu o acoperim.
    if (window.BiomeModals.any() && !modal) return;
    fetch('/cart?view=upsell', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html) return;
        var holder = document.createElement('div');
        holder.innerHTML = html;
        var payload = q('[data-br-upsell-payload]', holder);
        // Fara recomandare valida nu deschidem nimic. Mai bine zero fereastra
        // decat o fereastra goala.
        if (!payload || !q('.br-cart-upsell__item', payload)) return;

        destroy();
        var overlay = build(payload);
        if (!overlay) return;
        lastFocus = document.activeElement;
        modal = overlay;
        document.body.appendChild(overlay);
        window.BiomeModals.lock('atc');
        closeDrawer();
        window.requestAnimationFrame(function () { overlay.classList.add('is-open'); });
        var firstBtn = q('.br-cart-upsell__add', overlay);
        if (firstBtn && firstBtn.focus) { try { firstBtn.focus(); } catch (e) {} }
      }).catch(function () {});
  }

  function init() {
    document.addEventListener('keydown', onKey);

    // Marcam intentia reala de adaugare. Fara asta, orice reimprospatare de cos
    // ar deschide fereastra, inclusiv la incarcarea paginii.
    document.addEventListener('submit', function (event) {
      if (event.target.closest('.br-cart-upsell__form')) { suppress = true; return; }
      if (event.target.closest('form[action*="/cart/add"]')) pendingAdd = true;
    }, true);

    document.addEventListener('click', function (event) {
      if (event.target.closest('.br-cart-upsell__add')) { suppress = true; return; }
      if (event.target.closest('[data-add-to-cart], .add-to-cart, [name="add"]')) pendingAdd = true;
    }, true);

    document.addEventListener('ajaxProduct:added', function () {
      if (suppress) {
        // Adaugarea vine din fereastra. Reimprospatam cardul din ea, dar nu o
        // redeschidem, altfel intram intr-un ciclu.
        suppress = false;
        pendingAdd = false;
        window.setTimeout(function () {
          if (!modal) return;
          fetch('/cart?view=upsell', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
            .then(function (r) { return r.ok ? r.text() : ''; })
            .then(function (html) {
              if (!html || !modal) return;
              var holder = document.createElement('div');
              holder.innerHTML = html;
              var next = q('.br-cart-upsell__item', holder);
              var slot = q('.br-atc-modal__card', modal);
              if (next && slot) { slot.innerHTML = ''; slot.appendChild(next.cloneNode(true)); }
              else destroy();
            }).catch(function () {});
        }, 220);
        return;
      }
      if (!pendingAdd) return;
      pendingAdd = false;
      window.setTimeout(show, 260);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* Popup newsletter de homepage. Separat de logica de cos, dar in acelasi fisier
   (ambele sunt ferestre). Se randeaza doar pe homepage, prin theme.liquid. */
(function () {
  'use strict';
  var modal = document.querySelector('[data-br-news]');
  if (!modal) return;

  var COOKIE = 'br_news_seen';
  function seen() { return document.cookie.indexOf(COOKIE + '=1') !== -1; }
  function remember(days) {
    var d = new Date();
    d.setTime(d.getTime() + (Number(days) || 14) * 86400000);
    document.cookie = COOKIE + '=1; expires=' + d.toUTCString() + '; path=/; SameSite=Lax';
  }

  var opened = false, done = false;
  var cookieDays = Number(modal.getAttribute('data-cookie-days')) || 14;

  function open() {
    // Nu ne suprapunem peste fereastra de add-to-cart. Daca omul tocmai a
    // adaugat un produs, momentul ala e mai valoros decat inscrierea.
    if (opened || seen() || window.BiomeModals.any()) return;
    opened = true;
    modal.classList.add('is-ready');
    modal.setAttribute('aria-hidden', 'false');
    void modal.offsetWidth; // reflow, ca sa prinda tranzitia
    modal.classList.add('is-open');
    window.BiomeModals.lock('news');
    var email = modal.querySelector('input[type="email"]');
    if (email) { try { email.focus(); } catch (e) {} }
  }

  function close() {
    if (!modal.classList.contains('is-open')) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    window.BiomeModals.unlock('news');
    if (!done) remember(cookieDays); // respinsul se tine minte la fel ca inscrierea
    window.setTimeout(function () { if (!modal.classList.contains('is-open')) modal.classList.remove('is-ready'); }, 260);
  }

  modal.addEventListener('click', function (event) {
    if (event.target === modal || event.target.closest('[data-br-news-close]')) close();
  });
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' || event.keyCode === 27) close();
  });

  var form = modal.querySelector('form');
  if (form) {
    form.addEventListener('submit', function (event) {
      var email = form.querySelector('input[type="email"]');
      if (email && !email.checkValidity()) return; // lasam validarea nativa sa sara
      event.preventDefault();
      var btn = form.querySelector('button[type="submit"]');
      if (btn) btn.disabled = true;
      // Postam formularul de customer prin AJAX ca sa nu reincarcam pagina.
      // Daca reteaua pica, dam drumul la submit-ul nativ (customerul tot se salveaza).
      fetch(form.getAttribute('action') || '/contact', {
        method: 'POST',
        body: new FormData(form),
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      }).then(function () {
        done = true;
        remember(cookieDays);
        modal.classList.add('is-success');
        window.setTimeout(close, 2800);
      }).catch(function () {
        if (btn) btn.disabled = false;
        form.submit();
      });
    });
  }

  if (!seen()) {
    var delay = (Number(modal.getAttribute('data-delay')) || 6) * 1000;
    window.setTimeout(open, delay);
    // Exit-intent pe desktop: mouseul iese pe sus, semn ca pleaca.
    document.addEventListener('mouseout', function (event) {
      if (!event.relatedTarget && event.clientY <= 0) open();
    });
  }
})();
